import { render, staticRenderFns } from "./overLayText.vue?vue&type=template&id=29f02757&scoped=true"
import script from "./overLayText.vue?vue&type=script&lang=js"
export * from "./overLayText.vue?vue&type=script&lang=js"
import style0 from "./overLayText.vue?vue&type=style&index=0&id=29f02757&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f02757",
  null
  
)

export default component.exports